var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIArrowDownTransparent = function SvgIArrowDownTransparent(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 8,
    viewBox: "0 0 15 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.68299 6.81674C2.8002 6.93391 2.95914 6.99973 3.12487 6.99973C3.29059 6.99973 3.44954 6.93391 3.56674 6.81674L7.49987 2.88362L11.433 6.81674C11.5509 6.93059 11.7087 6.99359 11.8726 6.99216C12.0365 6.99074 12.1932 6.92501 12.3091 6.80913C12.425 6.69325 12.4907 6.53649 12.4922 6.37262C12.4936 6.20874 12.4306 6.05087 12.3167 5.93299L7.94174 1.55799C7.82454 1.44082 7.66559 1.375 7.49987 1.375C7.33414 1.375 7.1752 1.44082 7.05799 1.55799L2.68299 5.93299C2.56582 6.0502 2.5 6.20914 2.5 6.37487C2.5 6.54059 2.56582 6.69954 2.68299 6.81674Z",
    fill: "currentColor",
    stroke: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIArrowDownTransparent);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/i-arrow-down-transparent.067b17fd5a6f5383ec33a1fbbbe9338b.svg";